<div *ngIf="!hideAlert && alertContentDescription !== undefined" class="news-alert-box grid-column-one-full card-block">
	aria-live="polite">
	<button class="close-button" [disableRipple]="true" (click)="closeAlert()" type="button" mat-icon-button>
		<mat-icon svgIcon="md:close" color="accent"></mat-icon>
	</button>
	<span class="news-alert-title">
		<span>{{ alertTitle }}</span>
	</span>
	<span class="news-alert-description">
		<span [innerHTML]="alertContentDescription"></span>
	</span>
	<div class="news-view-details-button">
		<button type="button" mat-button color="primary" [routerLink]="['/home/news-card', alertList[0].id]" class="view-details-button-label">
			<span translate>news.detail</span>
			<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</div>
</div>